import React, { Component, Fragment } from 'react';
import get from 'lodash/get';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  Field, getFormValues, reduxForm, SubmissionError
} from 'redux-form';
import { withRouter } from 'react-router';

import { signup } from '../../../../actions/userActions';

import '../style.css';

const validate = (formProps) => {
  const errors = {};

  if (!formProps.email) {
    errors.email = 'Required';
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formProps.email)
  ) {
    errors.email = 'Invalid email address';
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { touched, error, warning },
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      <div
        className={`input-wrapper rounded  ${
          hasStatus ? 'has-' + hasStatus : ''
        }`}
      >
        <div className="text-left px-4">
          <small>{label}</small>
        </div>
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success border-0 px-4"
          {...input}
          disabled={disabled}
          type={type}
        />
      </div>
      {message ? (
        <div className="form-control-feedback">
          <small>{message}</small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

class SignUpForm extends Component {
  handleFormSubmit = (values) => {
    // clean up any user input
    // const userInput = trimUserInput(values);

    // pick off the values we want
    const { onSuccess, bookingData } = this.props;
    const { email, password } = values;

    return new Promise((resolve, reject) => {
      this.props.signup(
        email,
        null,
        password,
        bookingData,
        () => {
          resolve();
          onSuccess && onSuccess();
        },
        (error) => {
          reject(error);
        }
      );
    }).catch((ex) => {
      throw new SubmissionError({ _error: ex.message });
    });
  };

  render() {
    const { error, handleSubmit, submitting } = this.props;
    return (
      <form
        className="AuthForm SignUpForm form"
        onSubmit={handleSubmit(this.handleFormSubmit)}
      >
        <Field
          name="email"
          component={renderField}
          type="email"
          label="Email"
        />

        <Fragment>
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-cursor w-100"
            disabled={submitting}
            data-qa-id="continue-button"
          >
            Continue
          </button>
        </Fragment>

        {/*

  TODO: Re-enable google. We are temporarily disabling because our sign up flow
  has password setting in the flow. When we fix that, we can re-enable Google auth.

        {formValues && formValues.email ? (
          <Fragment>
            <button
              type="submit"
              className="btn btn-primary btn-lg btn-cursor w-100"
              disabled={pristine || submitting}>
              Get 7 Days Free
            </button>
          </Fragment>
        ) : (
          <Fragment>
            <p className="my-3">or</p>

            <GoogleButton
              text="Continue with Google"
              onClick={this.props.onGoogle}
              disabled={!this.props.gapiReady}
            />
          </Fragment>
        )}
*/}

        {
          // if an error exists, render an Alert
          error && <p className="text-danger my-2">{error}</p>
        }
      </form>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    initialValues: { email: get(props, 'location.query.email', '') },
    formValues: getFormValues('signUpForm')(state),
  };
}

export default compose(
  withRouter,
  connect(mapStateToProps, { signup }),
  reduxForm({ form: 'signUpForm', validate })
)(SignUpForm);



// WEBPACK FOOTER //
// ./src/components/forms/Auth/SignUpForm/index.js